document.addEventListener("turbo:load", function () {
  function copyValue(fromId, toId) {
    let original;
    let fromId$ = document.querySelector(fromId);
    let toId$ = document.querySelector(toId);

    fromId$.addEventListener("focus", (event) => {
      original = event.target.value;
    });
    fromId$.addEventListener("input", (event) => {
      if (toId$.val === "" || toId$.val === original) {
        toId$.val = event.target.value;
      }
      original = event.target.value;
    });
  }

  let attendeeWrapper = document.querySelector(
    '*[data-name="attendee-wrapper"]'
  );
  if (attendeeWrapper && attendeeWrapper.dataset["auto-copy"]) {
    copyValue(
      "#event_booking_first_name",
      "#event_booking_event_attendees_0_first_name"
    );
    copyValue(
      "#event_booking_last_name",
      "#event_booking_event_attendees_0_last_name"
    );
    copyValue("#event_booking_email", "#event_booking_event_attendees_0_email");
  }

  // Move coupon code section between desktop and mobile containers
  function moveCouponCodeSection() {
    const couponSection = document.getElementById('coupon-code-section');
    const desktopContainer = document.getElementById('coupon-code-desktop-container');
    const mobileContainer = document.getElementById('coupon-code-mobile-container');

    if (!couponSection || !desktopContainer || !mobileContainer) return;

    // Check if we're on mobile (< 992px)
    const isMobile = window.innerWidth < 992;

    if (isMobile) {
      // Move to mobile container if not already there
      if (couponSection.parentElement !== mobileContainer) {
        mobileContainer.appendChild(couponSection);
      }
    } else {
      // Move back to desktop container if not already there
      if (couponSection.parentElement !== desktopContainer) {
        desktopContainer.appendChild(couponSection);
      }
    }
  }

  // Run on load
  moveCouponCodeSection();

  // Run on resize with debounce to avoid too many calls
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(moveCouponCodeSection, 100);
  });
});

// commented out because we show prices server side on load
// Early price loading - simple and clean
// (function() {
//   function loadPricesEarly() {
//     // Call the function directly since it's in the same scope
//     let eventBookingAmount$ = document.getElementById("event_booking_amount");
//     if (eventBookingAmount$) {
//       getAndUpdatePrices();
//     }
//   }

//   // Try to load prices as soon as possible
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', loadPricesEarly);
//   } else {
//     loadPricesEarly();
//   }
// })();

// Global functions available immediately
function updateBookingAmountDisplay(source, target) {
  let source$ = document.querySelector(source);
  let target$ = document.querySelectorAll(target);
  target$.forEach(t => t.textContent = source$.value);
}

// Show loading state for price elements
function showPriceLoading() {
    const priceSelectors = [
      '#event_booking_total',
      '#event_booking_total_vat_included',
      '#event_booking_subtotal',
      '#event_booking_original',
      '#event_booking_reduced_by_super_earlybird',
      '#event_booking_reduced_by_earlybird',
      '#event_booking_reduced_by_coupon',
      '#event_booking_reduced_by_group_discount',
      '#event_booking_reduced_by_one_to_go_discount'
    ];

    priceSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(element => {
        // Store original content
        element.dataset.originalContent = element.textContent;
        // Show loading spinner
        element.innerHTML = '<span class="price-loading"></span>';
        element.classList.add('price-element-loading');
      });
    });
  }

// Hide loading state and restore content or set new content
function hidePriceLoading() {
  const priceSelectors = [
    '#event_booking_total',
    '#event_booking_total_vat_included',
    '#event_booking_subtotal',
    '#event_booking_original',
    '#event_booking_reduced_by_super_earlybird',
    '#event_booking_reduced_by_earlybird',
    '#event_booking_reduced_by_coupon',
    '#event_booking_reduced_by_group_discount',
    '#event_booking_reduced_by_one_to_go_discount'
  ];

  priceSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(element => {
      element.classList.remove('price-element-loading');
    });
  });
}

// Function to format numbers in German style (1.234,56)
function formatGermanNumber(value) {
    if (!value) return "0";

    // If the value is already formatted with commas as decimal separators, return it
    if (typeof value === 'string' && value.includes(',')) return value;

    // Convert to string if it's a number and replace . with , for decimal separator
    value = value.toString().replace('.', ',');

    // Add thousand separators
    if (value.includes(',')) {
      let parts = value.split(',');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join(',');
    } else {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
}

function getAndUpdatePrices() {
  let source$ = document.getElementById("event_booking_amount");
  let couponInput$ = document.getElementById("event_booking_coupon_code");

  // let eventBookingAddAttendeeWrapper$ = document.getElementById("event_booking_amount");
  // if (eventBookingAddAttendeeWrapper$) {
  //   // Check if it's a select element (has options) or input element (has max attribute)
  //   let maxBookableAmount = source$.options ? source$.options.length : (parseInt(source$.max) || 999);
  //   if (source$.value == maxBookableAmount) {
  //     eventBookingAddAttendeeWrapper$.classList.add("d-none");
  //   } else {
  //     eventBookingAddAttendeeWrapper$.classList.remove("d-none");
  //   }
  // }

  let params = new URLSearchParams({
    amount: source$.value
  });

  // Include coupon code from input field or data attribute
  let couponCode = couponInput$ ? couponInput$.value.trim() : source$.dataset.couponCode;
  if (couponCode) {
    params.append("coupon_code", couponCode);
  }

  // Only show loading animation if request takes longer than 400ms
  let loadingTimeout = setTimeout(() => {
    showPriceLoading();
  }, 400);

  fetch(`/api/events/${source$.dataset.eventId}/event_bookings/price?${params}`)
  .then(data => data.json())
  .then(data => {
    // Clear timeout and hide loading animation before updating content
    clearTimeout(loadingTimeout);
    hidePriceLoading();
    updatePriceDisplayFromData(data);
  })
  .catch(error => {
    // Clear timeout and hide loading animation on error
    clearTimeout(loadingTimeout);
    hidePriceLoading();
    // console.error('Price update error:', error);
  });
}

function updatePriceDisplayFromData(data) {
  // Update all price fields using data-price-field attribute
  // This automatically handles both desktop and mobile versions
  Object.keys(data).forEach(fieldName => {
    const elements = document.querySelectorAll(`[data-price-field="${fieldName}"]`);
    elements.forEach(element => {
      element.textContent = formatGermanNumber(data[fieldName]);
    });
  });

  // Update amount displays
  const amountInput = document.getElementById("event_booking_amount");
  if (amountInput) {
    const amount = parseInt(amountInput.value) || 1;

    document.querySelectorAll("[data-amount-display]").forEach(element => {
      element.textContent = amount;
    });

    // Show/hide per-person section based on attendee count
    // Only show "Preis pro Teilnehmenden" and multiplication if more than 1 attendee
    document.querySelectorAll(".price-per-person-section").forEach(element => {
      if (amount > 1) {
        element.classList.remove("d-none");
      } else {
        element.classList.add("d-none");
      }
    });
  }

  // Show/hide discount wrappers based on data-price-field
  const discountWrappers = [
    { field: 'item_super_early_bird_reduction', wrapper: '.super-earlybird-discount-wrapper' },
    { field: 'item_early_bird_reduction', wrapper: '.earlybird-discount-wrapper' },
    { field: 'item_one_to_go_reduction', wrapper: '.one-to-go-discount-wrapper' },
    { field: 'item_coupon_reduction', wrapper: '.coupon-discount-wrapper' }
  ];

  discountWrappers.forEach(({ field, wrapper }) => {
    const hasDiscount = parseFloat(data[field]) > 0;
    document.querySelectorAll(wrapper).forEach(element => {
      if (hasDiscount) {
        element.classList.remove("d-none");
      } else {
        element.classList.add("d-none");
      }
    });
  });

  // Handle group discount - show active or teaser
  if (parseFloat(data.total_group_discount_reduction) > 0) {
    document.querySelectorAll(".group-discount-wrapper").forEach(wrapper => {
      wrapper.classList.remove("d-none");
    });
    document.querySelectorAll(".group-discount-teaser").forEach(teaser => {
      teaser.classList.add("d-none");
    });
  } else {
    document.querySelectorAll(".group-discount-wrapper").forEach(wrapper => {
      wrapper.classList.add("d-none");
    });
    document.querySelectorAll(".group-discount-teaser").forEach(teaser => {
      teaser.classList.remove("d-none");
    });
  }
}

document.addEventListener("turbo:load", function () {
  let eventBookingAmount$ = document.getElementById("event_booking_amount");
  if (eventBookingAmount$) {
    let eventBookingAddAttendeeButton$ = document.getElementById("event_booking_add_attendee_button");
    if (eventBookingAddAttendeeButton$) {
      eventBookingAddAttendeeButton$
        .addEventListener("click", function () {
          if (eventBookingAmount$.selectedOptions[0].nextElementSibling) {
            let e = new Event("change");
            eventBookingAmount$.value = eventBookingAmount$.selectedOptions[0].nextElementSibling.value;
            eventBookingAmount$.dispatchEvent(e);
          }
        });
    }

    document
      .getElementById("event_booking_amount")
      .addEventListener("change", function () {
        getAndUpdatePrices();
      });
    // commented out because we show prices server side on load
    // getAndUpdatePrices();
  }

  // Add real-time coupon validation
  let couponInput$ = document.getElementById("event_booking_coupon_code");
  if (couponInput$ && eventBookingAmount$) {
    let couponValidationMessage$ = createCouponValidationMessage();
    couponInput$.parentNode.appendChild(couponValidationMessage$);

    // Debounced coupon validation
    let couponValidationTimeout;
    couponInput$.addEventListener("input", function() {
      // Clean up any existing validation messages first
      cleanupExistingCouponValidationMessages(couponInput$);

      // Hide validation message when user starts editing
      hideCouponValidationMessage();

      clearTimeout(couponValidationTimeout);
      couponValidationTimeout = setTimeout(() => {
        validateAndUpdateCoupon();
      }, 500);
    });

    couponInput$.addEventListener("blur", validateAndUpdateCoupon);
  }

  function cleanupExistingCouponValidationMessages(couponInput$) {
    // Remove existing invalid-feedback elements that might be from server-side validation
    let existingMessages = couponInput$.parentNode.querySelectorAll('.invalid-feedback');
    existingMessages.forEach(message => {
      // Don't remove our own AJAX validation message
      if (message.id !== 'coupon-validation-message') {
        message.remove();
      }
    });

    // Also remove the is-invalid class from the input if it exists
    couponInput$.classList.remove('is-invalid');
  }

  function createCouponValidationMessage() {
    let messageDiv = document.createElement('div');
    messageDiv.id = 'coupon-validation-message';
    messageDiv.className = 'invalid-feedback';
    messageDiv.style.display = 'none';
    return messageDiv;
  }

  function validateAndUpdateCoupon() {
    let couponInput$ = document.getElementById("event_booking_coupon_code");
    let amountSelect$ = document.getElementById("event_booking_amount");
    let validationMessage$ = document.getElementById("coupon-validation-message");

    if (!couponInput$ || !amountSelect$ || !validationMessage$) return;

    let couponCode = couponInput$.value.trim();

    if (!couponCode) {
      hideCouponValidationMessage();
      getAndUpdatePrices(); // Recalculate prices without coupon (will also hide coupon discount)
      return;
    }

    showCouponValidationMessage("Gutschein wird überprüft...", "info");

    // Only show loading animation if request takes longer than 400ms
    let loadingTimeout = setTimeout(() => {
      showPriceLoading();
    }, 400);

    fetch(`/api/events/${amountSelect$.dataset.eventId}/event_bookings/validate_coupon`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCSRFToken()
      },
      body: JSON.stringify({
        coupon_code: couponCode,
        amount: amountSelect$.value
      })
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    })
    .then(data => {
      // Clear timeout and hide loading animation before updating content
      clearTimeout(loadingTimeout);
      hidePriceLoading();
      if (data.valid) {
        showCouponValidationMessage(data.message, "success");
        updatePriceDisplayFromData(data.prices);
      } else {
        showCouponValidationMessage(data.message, "error");
        // Don't hide loading here, let getAndUpdatePrices handle it
        getAndUpdatePrices(); // Recalculate prices without coupon (will also hide coupon discount)
      }
    })
    .catch(error => {
      // Clear timeout and hide loading animation on error and restore original content
      clearTimeout(loadingTimeout);
      hidePriceLoading(true);
      console.error('Coupon validation error:', error);
      showCouponValidationMessage('Fehler bei der Gutschein-Überprüfung', "error");
      // Use the non-loading version since we're already showing loading
      getAndUpdatePricesWithoutLoading(); // Recalculate prices without coupon (will also hide coupon discount)
    });
  }


  function showCouponValidationMessage(message, type) {
    let validationMessage$ = document.getElementById("coupon-validation-message");
    let couponInput$ = document.getElementById("event_booking_coupon_code");

    if (!validationMessage$ || !couponInput$) return;

    validationMessage$.textContent = message;
    validationMessage$.className = `invalid-feedback text-${getBootstrapClass(type)}`;
    validationMessage$.style.display = 'block';

    // Add or remove is-invalid class based on validation result
    if (type === 'error') {
      couponInput$.classList.add('is-invalid');
    } else {
      couponInput$.classList.remove('is-invalid');
    }
  }

  function hideCouponValidationMessage() {
    let validationMessage$ = document.getElementById("coupon-validation-message");
    let couponInput$ = document.getElementById("event_booking_coupon_code");

    if (validationMessage$) {
      validationMessage$.style.display = 'none';
    }

    if (couponInput$) {
      couponInput$.classList.remove('is-invalid');
    }
  }

  function getBootstrapClass(type) {
    const classes = {
      'success': 'success',
      'error': 'danger',
      'info': 'muted'
    };
    return classes[type] || 'muted';
  }

  function getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]');
    return token ? token.getAttribute('content') : '';
  }
});

document.addEventListener("turbo:load", function () {
  // remove values from attendee inputs
  let resetAttendeeInputs = function resetAttendeeInputs(attendee) {
    attendee.querySelectorAll("input[id$=first_name]").forEach(function (elm) {
      elm.value = "";
    });
    attendee.querySelectorAll("input[id$=last_name]").forEach(function (elm) {
      elm.value = "";
    });
    attendee.querySelectorAll("input[id$=email]").forEach(function (elm) {
      elm.value = "";
    });
  };

  // set correct index of attendee array
  let orderAttendees = function orderAttendees() {
    let attendeeWrapper = document.querySelector(
        '*[data-name="attendee-wrapper"]'
      );

    if (!attendeeWrapper) return;

    let allAttendeeRows = attendeeWrapper.querySelectorAll(
        '*[data-name="attendee"]'
      );

    allAttendeeRows.forEach(function (element, index) {
      element
        .querySelector("label[for$=first_name]")
        .setAttribute(
          "for",
          `event_booking_event_attendees_${index}_first_name`
        );
      element
        .querySelector("input[id$=first_name]")
        .setAttribute(
          "id",
          `event_booking_event_attendees_${index}_first_name`
        );
      element
        .querySelector("input[id$=first_name]")
        .setAttribute(
          "name",
          `event_booking[event_attendees][${index}][first_name]`
        );
      element
        .querySelector("label[for$=last_name]")
        .setAttribute(
          "for",
          `event_booking_event_attendees_${index}_last_name`
        );
      element
        .querySelector("input[id$=last_name]")
        .setAttribute("id", `event_booking_event_attendees_${index}_last_name`);
      element
        .querySelector("input[id$=last_name]")
        .setAttribute(
          "name",
          `event_booking[event_attendees][${index}][last_name]`
        );
      element
        .querySelector("label[for$=email]")
        .setAttribute("for", `event_booking_event_attendees_${index}_email`);
      element
        .querySelector("input[id$=email]")
        .setAttribute("id", `event_booking_event_attendees_${index}_email`);
      element
        .querySelector("input[id$=email]")
        .setAttribute(
          "name",
          `event_booking[event_attendees][${index}][email]`
        );
    });
  };

  let updateRows = function () {
    let selectedAttendeeCount = document.querySelector("#event_booking_amount")
      .value;
    let attendeeWrapper = document.querySelector(
      '*[data-name="attendee-wrapper"]'
    );

    if (!attendeeWrapper) return;

    let allAttendeeRows = attendeeWrapper.querySelectorAll(
      '*[data-name="attendee"]'
    );

    allAttendeeRows.forEach(function (element, index) {
      if (index >= selectedAttendeeCount) {
        allAttendeeRows[index].remove();
      }
    });

    attendeeWrapper = document.querySelector('*[data-name="attendee-wrapper"]');
    if (!attendeeWrapper) return;

    allAttendeeRows = attendeeWrapper.querySelectorAll(
      '*[data-name="attendee"]'
    );

    let attendeesToAddCount = selectedAttendeeCount - allAttendeeRows.length;
    if (attendeesToAddCount > 0) {
      let firstAttendee = allAttendeeRows[0];
      let clone;

      for (let i = 0; i < attendeesToAddCount; i++) {
        clone = firstAttendee.cloneNode(true);
        resetAttendeeInputs(clone);
        attendeeWrapper.appendChild(clone);
      }
    }

    orderAttendees();
  };

  let eventBookingAmount$ = document.getElementById("event_booking_amount");
  if (eventBookingAmount$) {
    eventBookingAmount$.addEventListener("change", updateRows);
  }
});
